/**
 * BrewNectar Compare Product Lineup — fade-up
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFadeUp(section) {
    var animated = section.querySelectorAll('.bn-cpl__animate');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = section.getAttribute('data-bn-cpl-observer-margin') || '-60px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initSection(section) {
    if (!section || section.dataset.bnCplInit === 'true') return;
    section.dataset.bnCplInit = 'true';
    initFadeUp(section);
  }

  function initAll() {
    document.querySelectorAll('.bn-cpl').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bn-cpl');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('.bn-cpl');
    if (section) delete section.dataset.bnCplInit;
  });
})();
